import { GuestDto, MemberRole, TenantDto, UserDto } from '@nusign/picflow-backend-types';

import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, filter, merge, startWith } from 'rxjs';
import { AuthToken } from '../classes/authToken';
import { RecurringInterval } from '../types/product.type';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  public nextPageIsNotFound: boolean;
  public temporarilyHideUpgradeCta = false;
  public extensionTabId: number;

  public impersonating: boolean;
  public user: UserDto;
  public user$ = new BehaviorSubject<UserDto>(undefined);
  public tokenData: AuthToken;
  public tenants: TenantDto[];
  public activeTenant$ = new BehaviorSubject<TenantDto>(undefined);
  public activeTenantRole: MemberRole | 'guest';
  public sharedWithMeActiveTenant$ = new BehaviorSubject<TenantDto>(undefined);
  public sharedWithMeTenants: TenantDto[];
  public currentTenant$ = merge(
    this.activeTenant$.pipe(filter(Boolean)),
    this.sharedWithMeActiveTenant$.pipe(filter(Boolean))
  ).pipe(startWith(undefined));

  public guest: GuestDto;
  public guestAuthToken: string;
  public preGuestAnonymousId: string;
  public renewGuestAuthToken = async () => console.error('Guest-auth service not loaded');
  public visitingTenant: TenantDto; // gallery view pages

  public unseenActivity = 0;
  public unseenActivityCountMap: Map<string, number> = new Map();

  public billingFrequency = signal<RecurringInterval>('year');

  public galleryPreviewMode = false;
  public galleryPreviewModeIdentified = false;
  public loggingOut = signal(false);
}
